import { alpha, Theme } from '@mui/material/styles';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import { AppMarginsStyleClasses } from "assets/jss/common-styles";
import classNames from "classnames";
import * as CSS from "csstype";
import * as React from "react";

const style = (theme: Theme) => createStyles({

    ...AppMarginsStyleClasses(theme),

    container: {
        position: "relative"
    },

    hideOverflow: {
        display: "block",
        width: "100%",
        overflowY: "auto",
        overflowX: "hidden",
    },

    flex: {
        display: "flex"
    },

    backdrop: {
        zIndex: theme.zIndex.mobileStepper,
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: alpha(theme.palette.common.black, 0.1)
    }
});

type Margin = 'none' | 'dense' | 'normal' | 'large';

interface IProps {
    align?: CSS.Property.TextAlign;
    backdrop?: boolean;
    className?: string;
    flex?: boolean;
    height?: number | string;
    margin?: Margin;
    maxHeight?: number | string;
    overflow?: boolean;
    sideMargins?: Margin;
}

type Props = IProps & WithStyles<typeof style>;

const MuiContainer: React.FC<Props> = (props) => {
    const { align, backdrop, children, className, classes, flex, height, margin, maxHeight, sideMargins } = props;

    const cardClasses = classNames(
        {
            [classes.container]: true,
            ["" + align]: align !== undefined,
            [classes.flex]: flex,
            [classes.hideOverflow]: height || maxHeight,
            [classes.marginBottomDense]: margin == "dense",
            [classes.marginBottomNormal]: margin == "normal",
            [classes.marginBottomLarge]: margin == "large",
            [classes.sideMarginsDense]: sideMargins == "dense",
            [classes.sideMarginsNormal]: sideMargins == "normal",
            [classes.sideMarginsLarge]: sideMargins == "large",
            [className]: className,
        });

    const styles = {};
    if (maxHeight) styles["maxHeight"] = maxHeight;
    if (height) styles["height"] = height;


    return (
        <div className={cardClasses} style={styles}>
            {backdrop && <div className={classes.backdrop}></div>}
            {children}
        </div>
    );
}

MuiContainer.defaultProps = {
    margin: "normal"
}

export default withStyles(style)(MuiContainer);
